import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Development ortamında react-snap uyarılarını bastır
if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    // react-snap'in UNSAFE_componentWillMount uyarısını bastır
    if (
      args[0] &&
      typeof args[0] === 'string' &&
      (args[0].includes('UNSAFE_componentWillMount') ||
       args[0].includes('installHook') ||
       args[0].includes('SideEffect'))
    ) {
      return;
    }
    originalWarn.apply(console, args);
  };
}

const container = document.getElementById('root');

// react-snap için hydrate desteği
// react-snap pre-rendering sırasında StrictMode uyarıları verebilir, bu normaldir
if (container.hasChildNodes()) {
  hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
